import { createContext, useContext, type ReactElement, type ReactNode } from 'react';

interface EatalyHeaderChromeContextValue {
    headerHidden: boolean;
}

const EatalyHeaderChromeContext = createContext<EatalyHeaderChromeContextValue>({ headerHidden: false });

export function EatalyHeaderChromeProvider({
    headerHidden,
    children,
}: {
    headerHidden: boolean;
    children: ReactNode;
}): ReactElement {
    return <EatalyHeaderChromeContext.Provider value={{ headerHidden }}>{children}</EatalyHeaderChromeContext.Provider>;
}

// eslint-disable-next-line react-refresh/only-export-components
export function useEatalyHeaderChrome(): EatalyHeaderChromeContextValue {
    return useContext(EatalyHeaderChromeContext);
}
